import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { faturaService } from '@/services/fatura.service'
import type { ListFilters } from '@/services/associado.service'

export function useFaturas(filters: ListFilters & { associado_id?: string; contrato_id?: string; cpf?: string } = {}) {
    return useQuery({
        queryKey: ['faturas', filters],
        queryFn: () => faturaService.list(filters),
    })
}

export function useFatura(id: string | null) {
    return useQuery({
        queryKey: ['fatura', id],
        queryFn: () => faturaService.getById(id!),
        enabled: !!id,
    })
}

export function useMarcarFaturaPaga() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (id: string) => faturaService.marcarPaga(id),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['faturas'] })
            qc.invalidateQueries({ queryKey: ['fatura'] })
        },
    })
}

export function useGerarProRata() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (id: string) => faturaService.gerarProRata(id),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['faturas'] })
            qc.invalidateQueries({ queryKey: ['fatura'] })
        },
    })
}
